var map = {
	"./banana-bread-oats.png": 828,
	"./banana-pancakes.png": 795,
	"./berry-banana-smoothie.png": 323,
	"./breakfast-tacos.png": 953,
	"./chickpea-veggie-pasta.png": 708,
	"./cucumber-chips.png": 32,
	"./meatless-burrito-bowl.png": 499,
	"./overnight-oats.png": 580,
	"./salted-chocolate-covered-oranges.png": 919,
	"./smoothie-bowl.png": 731,
	"./vegetarian-protein-pasta.png": 12
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;